import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useFormik } from "formik";
import * as Yup from "yup";
import { UsersApi } from "../../../services/users";
import { useEffect, useState, useRef } from 'react';
import PhoneInput from 'react-phone-input-2'
import 'react-phone-input-2/lib/style.css';
import { FaArrowLeft } from 'react-icons/fa';
import { PayableSalaryApi } from '../../../services/payableSalary';
// import wordsToNumbers from 'words-to-numbers';


interface Buttonstype {
  employeeCode: string,
  // natureOfEmployment: string,
  gender: string,
  salutation:string,
  firstName: string,
  middleName: string,
  lastName: string,
  email: string,
  personalContactEmailId: string,
  // role: string,
  matrixLevel: string,
  countryCode: number | undefined,
  mobile: number | undefined,
  personalContactNumber: number | undefined,
  // emergencyContactNumber: number | undefined,
  // personalContactEmailId: string,
  // aadharCardDetails: string,
  // panCardDetails: string,
  permanentAddress: string,
  currentAddress: string,
  // emergencyContactPerson: string,
  bloodGroup: string,
  age: number,
  experienceYear: string | number,
  monthlySalary: number,
  joiningDate: string,
  dateOfBirth: string,
  designation: string,
  department: string,
  managerId: string,
  isTeacher: string,
  location: string,
  qualificationAtAppointment: string,
  universityAccommodation: boolean | undefined,
  category: string,
  // residentIndia: string,
}

interface MatrixDataItem {
  [key: string]: any;
}
const boardUpSchema = Yup.object({
  salutation: Yup.string().min(2).max(10).required('Salutation is required !'),
  firstName: Yup.string().max(25).required('Enter Your First Name !'),
  middleName: Yup.string().max(25).required('Enter Your Middle Name !'),
  lastName: Yup.string().max(25).required('Enter Your Last Name !'),
  email: Yup.string().email().required("Enter Your Email !"),
  personalContactEmailId: Yup.string().email().required("Enter Your Personal Email !"),
  employeeCode: Yup.string().required('Employee Code is required!'),
  designation: Yup.string().required('Designation is required!'),
  monthlySalary: Yup.number().required("Annual Salary is required").typeError('Annual Salary ir required'),
  experienceYear: Yup.number()
    .transform((value, originalValue) => originalValue === '' ? undefined : value)
    .required("Working Experience is required")
    .typeError('Working Experience is required'),
  qualificationAtAppointment: Yup.string().required('Enter Qualification At The Time Of Appointment!'),
  bloodGroup: Yup.string().required("Enter Your Blood Group!"),
  universityAccommodation: Yup.boolean().required('Select University Accommodation!'),
  category: Yup.string().required('Enter Category!'),
  age: Yup.number().required("Age is required").typeError('Age is required'),
  // role: Yup.string().required("Select Role !"),
  countryCode: Yup.mixed(),
  mobile: Yup.number()
    .required('Mobile number is required')
    .test('is-ten-digits', 'Mobile number must have exactly 10 digits', (value) => {
      if (!value) return false;
      return /^\d{10}$/.test(value.toString());
    }),
  personalContactNumber: Yup.number()
    .required('Mobile number is required')
    .test('is-ten-digits', 'Mobile number must have exactly 10 digits', (value) => {
      if (!value) return false;
      return /^\d{10}$/.test(value.toString());
    }),
  permanentAddress: Yup.string().required("Enter Your Permanent Address !"),
  joiningDate: Yup.string().min(4).max(20).required('Enter Your Hiring Date !'),
  currentAddress: Yup.string().min(4).max(20).required('Enter Your Current Address !'),
  department: Yup.string().required('Select Your Department Name!'),
  location: Yup.string().required('Select Your Location !'),
  dateOfBirth: Yup.date().max(new Date(new Date().getFullYear() - 18, new Date().getMonth(), new Date().getDate()).toISOString().split("T")[0], ({ max }) => `Date Of Birth must be earlier than ${max}`).required("Enter your date of birth"),
  isTeacher: Yup.string().oneOf(["true", "false"], "Select Teaching or Non-Teaching!").required("Select Teaching or Non-Teaching!"),
  gender: Yup.string().required("Select Your Gender!"),
})



function PeopleUser(props: any) {
  const { postusers, getAllManager, getAllDepartment, getAllJobRole, postCheckEmail, getAlllevel } = UsersApi();
  // const [roles, setRoles] = useState([]);
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [managers, setManager] = useState([]);
  const [departments, setDepartment] = useState([]);
  const [jobRole, setJobRole] = useState([]);
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [salaryLevel, setSalaryLevel] = useState([]);
  const { getMatrixData } = PayableSalaryApi();
  const [matrixAllData, setMatrixData] = useState<MatrixDataItem[]>([]);
  const emailDebounceRef = useRef<NodeJS.Timeout | null>(null);
  const empCodeDebounceRef = useRef<NodeJS.Timeout | null>(null);

  const formIk = useFormik<Buttonstype>({
    validationSchema: boardUpSchema,
    initialValues: {
      employeeCode: "",
      salutation: "",
      firstName: "",
      middleName: "",
      lastName: "",
      email: "",
      personalContactEmailId: "",
      matrixLevel: "",
      // personalContactEmailId: "",
      monthlySalary: 0,
      experienceYear: "",
      qualificationAtAppointment: "",
      bloodGroup: "",
      universityAccommodation: undefined,
      category: "",
      // bloodGroup: "",
      age: 0,
      // role: "",
      mobile: undefined,
      personalContactNumber: undefined,
      // emergencyContactNumber: undefined,
      permanentAddress: "",
      currentAddress: "",
      countryCode: undefined,
      joiningDate: "",
      dateOfBirth: "",
      designation: "",
      department: "",
      managerId: "",
      isTeacher: "",
      location: "",
      gender: ""
    },
    onSubmit: async (values, formikHelpers) => {
      // Convert isTeacher to boolean for API if needed
      const valuesToSubmit = {
        ...values,
        isTeacher: values.isTeacher === "true"
      };
      // Set all fields as touched so errors show for all fields
      formikHelpers.setTouched({
        employeeCode: true,
        salutation: true,
        firstName: true,
        middleName: true,
        lastName: true,
        email: true,
        personalContactEmailId: true,
        matrixLevel: true,
        countryCode: true,
        mobile: true,
        personalContactNumber: true,
        permanentAddress: true,
        currentAddress: true,
        bloodGroup: true,
        age: true,
        experienceYear: true,
        monthlySalary: true,
        joiningDate: true,
        dateOfBirth: true,
        designation: true,
        department: true,
        managerId: true,
        isTeacher: true,
        location: true,
        qualificationAtAppointment: true,
        universityAccommodation: true,
        category: true,
      });
      try {
        const response = await postusers(valuesToSubmit);
        if (response && response.status === 200) {
          toast.success('Form submitted successfully!');
          setTimeout(() => {
            props.close();
          }, 1000);
        } else {
          toast.error('Form submission failed!');
        }
      } catch (error) {
        console.error('An error occurred:', error);
        toast.error('Form submission failed due to an error.');
      }
    },
  });
  useEffect(() => {
    // getRole();
    getDepartment();
    getAllJobRoles();
    // getAllsalaryLevel();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  // const getRole = async () => {
  //   const roles = await AssignAllRole();
  //   setRoles(roles.data);
  // }

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const getManager = async (user: string) => {
    const managers = await getAllManager(user);
    setManager(managers.data)

  }

  const getDepartment = async () => {
    const departments = await getAllDepartment();
    setDepartment(departments.data)

  }

  const getAllJobRoles = async () => {
    const Designation = await getAllJobRole()
    setJobRole(Designation.data.data)

  }

  // const getAllsalaryLevel = async () => {
  //   // console.log(matrixLevel);

  //   const salaryLevelData = await getAlllevel(matrixLevel)
  //   console.log(salaryLevelData);

  //   setSalaryLevel(salaryLevelData.data)

  // }
  // const handleLevelChange = async (e: any) => {
  //   const { value } = e.target;
  //   formIk.handleChange(e); // Update formIk state

  //   // Fetch and set the salary data based on the selected level
  //   const salaryLevelData = await getAlllevel(value);
  //   setSalaryLevel(salaryLevelData.data)
  //   // Update local state with salary options
  //   formIk.setFieldValue('monthlySalary', ''); // Reset monthlySalary selection
  // };

  // const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
  //   const selectedValue = event.target.value === "true";
  //   formIk.setFieldValue("isTeacher", selectedValue ? "true" : "false");
  //   if (selectedValue) {
  //     getManager("true");
  //   } else {
  //     getManager("false");
  //   }
  // };

  const fullPhoneNumber = typeof formIk.values.mobile === 'number'
    ? `${formIk.values.mobile}`
    : '';

  const calculateAge = (dateOfBirth: string): number => {
    const birthDate = new Date(dateOfBirth);
    const today = new Date();
    let age = today.getFullYear() - birthDate.getFullYear();
    const monthDifference = today.getMonth() - birthDate.getMonth();

    // Adjust age if the birth date hasn't occurred yet this year
    if (monthDifference < 0 || (monthDifference === 0 && today.getDate() < birthDate.getDate())) {
      age--;
    }
    return age;
  };

  const handleDateChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const dateOfBirth = e.target.value;
    formIk.setFieldValue('dateOfBirth', dateOfBirth);

    if (dateOfBirth) {
      const age = calculateAge(dateOfBirth);
      formIk.setFieldValue('age', age.toString());
    } else {
      formIk.setFieldValue('age', '');
    }
  };

  const fetchMatrixData = async () => {
    try {
      const response = await getMatrixData();
      setMatrixData(response.data.data);
    } catch (error) {
      console.error('Error fetching matrix data:', error);
      // Handle error here, such as displaying an error message to the user
    }
  };

  useEffect(() => {
    fetchMatrixData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  // const fetchMatrixData = async () => {
  //   try {
  //     const response = await getMatrixData();
  //     setMatrixData(response.data.data);
  //   } catch (error) {
  //     console.error("Error fetching matrix data:", error);
  //     // Handle error here, such as displaying an error message to the user
  //   }
  // };
  // const convertColumnName = (name: string) => {
  //   if (name === 'experienceYear') return "Experience In Year";
  //   if (name === 'levelThirteenk') return "Level 13(C)";
  //   const match = name.match(/level(\w+)/);
  //   if (match) {
  //     const numericPart = wordsToNumbers(match[1]);
  //     return `Level ${numericPart}`;
  //   }

  //   return name;
  // };

  const columnsToSkip = ['id', 'experienceYear', 'updatedAt', 'createdAt'];
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const filteredKeys = Object.keys(matrixAllData[0] || {}).filter(
    (key) => !columnsToSkip.includes(key)
  );
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const handleLevelChange = async (e: { target: { value: any; }; }) => {
    const { value } = e.target;
    formIk.handleChange(e); // Update formik state

    // Fetch and set the salary data based on the selected level
    try {
      const salaryLevelData = await getAlllevel(value); // Inspect the structure of the data
      // Assuming salaryLevelData.data is an array of objects
      const formattedSalaryLevels = salaryLevelData.data.map((salary: { [x: string]: any; }) => {
        const key = Object.keys(salary)[0]; // Get the first key (e.g., 'levelOne')
        return salary[key]; // Extract the value corresponding to the key
      });
      setSalaryLevel(formattedSalaryLevels);
    } catch (error) {
      console.error('Error fetching salary level data:', error);
    }

    formIk.setFieldValue('monthlySalary', 0); // Reset monthlySalary selection
  };

  useEffect(() => {
    if (formIk.values.email) {
      if (emailDebounceRef.current) clearTimeout(emailDebounceRef.current);
      emailDebounceRef.current = setTimeout(async () => {
        try {
          const response = await postCheckEmail(formIk.values.email, 'email');
          if (response.data.status === 400) {
            toast.error(response.data.message);
          }
        } catch (error) {
          toast.error('Error checking email');
        }
      }, 1000);
    }
    return () => {
      if (emailDebounceRef.current) clearTimeout(emailDebounceRef.current);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [formIk.values.email]);

  useEffect(() => {
    if (formIk.values.employeeCode) {
      if (empCodeDebounceRef.current) clearTimeout(empCodeDebounceRef.current);
      empCodeDebounceRef.current = setTimeout(async () => {
        try {
          const response = await postCheckEmail(formIk.values.employeeCode, 'employeeCode');
          if (response.data.status === 400) {
            toast.error(response.data.message);
          }
        } catch (error) {
          toast.error('Error checking employee code');
        }
      }, 1000);
    }
    return () => {
      if (empCodeDebounceRef.current) clearTimeout(empCodeDebounceRef.current);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [formIk.values.employeeCode]);

  return (
    <div className="w-full bg-white p-5 mt-5 mb-5 rounded-lg shadow-lg" >
      <div className='float-right text-black p-2'>
        <FaArrowLeft className='fill-blue-500 font-bold text-3xl' onClick={() => props.close()}
          data-tooltip-id={'my-tooltip'} data-tooltip-content="Back to People" />
      </div>
      <form
        className="p-4 mt-10 bg-white border border-t-gray-300 rounded-lg w-3/4 mx-auto shadow-md"
        onSubmit={formIk.handleSubmit}
      >
        <div >

          <h1>Employee Onboarding</h1>
          <br />
          {/* 1. Employee Details */}
          <label className='block text-left mb-[5px]' htmlFor="employeeCode">Employee Code</label>
          <input className="w-full border mb-2.5 p-2 rounded-[3px] border-solid border-[#ccc]"
            type="text"
            id="employeeCode"
            name="employeeCode"
            value={formIk.values.employeeCode}
            onChange={formIk.handleChange}
            onBlur={formIk.handleBlur}
            placeholder="Employee Code"
          />
          {formIk.errors.employeeCode && formIk.touched.employeeCode ? (
            <label className="text-sm text-red-600 block text-left mb-[5px]">{formIk.errors.employeeCode}</label>
          ) : null}

          <label className='block text-left mb-[5px]' htmlFor="salutation">Salutation</label>
          <input className="w-full border mb-2.5 p-2 rounded-[3px] border-solid border-[#ccc]"
            type="text"
            id="salutation"
            name="salutation"
            value={formIk.values.salutation}
            onChange={formIk.handleChange}
            onBlur={formIk.handleBlur}
            placeholder="Salutation"
          />
          {formIk.errors.salutation && formIk.touched.salutation ? (
            <label className="text-sm text-red-600 block text-left mb-[5px]">{formIk.errors.salutation}</label>
          ) : null}

          <label className='block text-left mb-[5px]' htmlFor="firstName">First Name</label>
          <input className="w-full border mb-2.5 p-2 rounded-[3px] border-solid border-[#ccc]"
            type="text"
            id="firstName"
            name="firstName"
            value={formIk.values.firstName}
            onChange={formIk.handleChange}
            onBlur={formIk.handleBlur}
            placeholder="Name"
          />
          {formIk.errors.firstName && formIk.touched.firstName ? (
            <label className="text-sm text-red-600 block text-left mb-[5px]">{formIk.errors.firstName}</label>
          ) : null}

          <label className='block text-left mb-[5px]' htmlFor="middleName">Middle Name</label>
          <input className="w-full border mb-2.5 p-2 rounded-[3px] border-solid border-[#ccc]"
            type="text"
            id="middleName"
            name="middleName"
            value={formIk.values.middleName}
            onChange={formIk.handleChange}
            onBlur={formIk.handleBlur}
            placeholder="Middle Name"
          />
          {formIk.errors.middleName && formIk.touched.middleName ? (
            <label className="text-sm text-red-600 block text-left mb-[5px]">{formIk.errors.middleName}</label>
          ) : null}

          <label className='block text-left mb-[5px]' htmlFor="lastName">Last Name</label>
          <input className="w-full border mb-2.5 p-2 rounded-[3px] border-solid border-[#ccc]"
            type="text"
            id="lastName"
            name="lastName"
            value={formIk.values.lastName}
            onChange={formIk.handleChange}
            onBlur={formIk.handleBlur}
            placeholder="Name"
          />
          {formIk.errors.lastName && formIk.touched.lastName ? (
            <label className="text-sm text-red-600 block text-left mb-[5px]">{formIk.errors.lastName}</label>
          ) : null}

          <div className="text-left">
            <h1 >Select Your Gender ?</h1>
            <div>
              <input
                type="radio"
                id="gender"
                name="gender"
                value="Male"
                checked={formIk.values.gender === "Male"}
                onChange={formIk.handleChange}
                onBlur={formIk.handleBlur}
              />
              <label htmlFor="Male" className="ml-2">
                Male
              </label>
            </div>
            <div>
              <input
                type="radio"
                id="gender"
                name="gender"
                value="Female"
                checked={formIk.values.gender === "Female"}
                onChange={formIk.handleChange}
                onBlur={formIk.handleBlur}
              />
              <label htmlFor="Female" className="ml-2">
                Female
              </label>
            </div>
            <div>
              <input
                type="radio"
                id="gender"
                name="gender"
                value="Other"
                checked={formIk.values.gender === "Other"}
                onChange={formIk.handleChange}
                onBlur={formIk.handleBlur}
              />
              <label htmlFor="other" className="ml-2">
                Other
              </label>
            </div>
            {formIk.errors.gender ? (
              <label className="text-sm text-red-600 block text-left mb-[5px]">{formIk.errors.gender}</label>
            ) : null}
          </div>

          <label className='block text-left mb-[5px]' htmlFor="dateOfBirth">Date of Birth</label>
          <input
            className="h-10 border w-full text-[32] p-2 rounded-[3px] border-solid border-[#ccc]"
            type="date"
            max={new Date(new Date().getFullYear() - 18, new Date().getMonth(), new Date().getDate()).toISOString().split("T")[0]}
            onInvalid={(e) => { e.preventDefault(); }}
            id="dateOfBirth"
            name="dateOfBirth"
            value={formIk.values.dateOfBirth}
            onChange={handleDateChange}
            onBlur={formIk.handleBlur}
            placeholder="Date"
          />
          {formIk.errors.dateOfBirth && formIk.touched.dateOfBirth ? (
            <label className="text-sm text-red-600 block text-left mb-[5px]">{formIk.errors.dateOfBirth}</label>
          ) : null}

          <label className='block text-left mb-[5px]' htmlFor="age">Enter Your Age</label>
          <input
            className="w-full border mb-2.5 p-2 rounded-[3px] border-solid border-[#ccc]"
            type="text"
            placeholder="Enter Age"
            id="age"
            name="age"
            value={formIk.values.age}
            onChange={formIk.handleChange}
            onBlur={formIk.handleBlur}
            pattern="[0-9]{1,2}"
            inputMode="numeric"
            maxLength={3}
          />

          <label className='block text-left mb-[5px]' htmlFor="bloodGroup">Blood Group</label>
          <input className="w-full border mb-2.5 p-2 rounded-[3px] border-solid border-[#ccc]"
            type="text"
            id="bloodGroup"
            name="bloodGroup"
            value={formIk.values.bloodGroup}
            onChange={formIk.handleChange}
            onBlur={formIk.handleBlur}
            placeholder="Blood Group"
          />
          {formIk.errors.bloodGroup && formIk.touched.bloodGroup ? (
            <label className="text-sm text-red-600 block text-left mb-[5px]">{formIk.errors.bloodGroup}</label>
          ) : null}

          <label className='block text-left mb-[5px]' htmlFor="category">Category</label>
          <input className="w-full border mb-2.5 p-2 rounded-[3px] border-solid border-[#ccc]"
            type="text"
            id="category"
            name="category"
            value={formIk.values.category}
            onChange={formIk.handleChange}
            onBlur={formIk.handleBlur}
            placeholder="Category"
          />
          {formIk.errors.category && formIk.touched.category ? (
            <label className="text-sm text-red-600 block text-left mb-[5px]">{formIk.errors.category}</label>
          ) : null}

          {/* 2. Contact Information */}
          <label className='block text-left mb-[5px]' htmlFor="email">Email ID-Official</label>
          <input className="w-full border mb-2.5 p-2 rounded-[3px] border-solid border-[#ccc]"
            type="text"
            id="email"
            name="email"
            value={formIk.values.email}
            onChange={formIk.handleChange}
            onBlur={formIk.handleBlur}
            placeholder="Email"
          />
          {formIk.errors.email && formIk.touched.email ? (
            <label className="text-sm text-red-600 block text-left mb-[5px]">{formIk.errors.email}</label>
          ) : null}

          <label className='block text-left mb-[5px]' htmlFor="personalContactEmailId">Personal Email</label>
          <input className="w-full border mb-2.5 p-2 rounded-[3px] border-solid border-[#ccc]"
            type="email"
            id="personalContactEmailId"
            name="personalContactEmailId"
            value={formIk.values.personalContactEmailId}
            onChange={formIk.handleChange}
            onBlur={formIk.handleBlur}
            placeholder="Personal Email"
          />
          {formIk.errors.personalContactEmailId && formIk.touched.personalContactEmailId ? (
            <label className="text-sm text-red-600 block text-left mb-[5px]">{formIk.errors.personalContactEmailId}</label>
          ) : null}

          <div>
            <label className='block text-left mb-[5px]' htmlFor="mobile">Mobile Number</label>
            <PhoneInput
              country={'in'}
              value={fullPhoneNumber}
              onChange={(phone, countryInfo) => {
                if (typeof phone === 'string' && countryInfo && typeof countryInfo === 'object') {
                  const numericPhone = phone.replace(/\D/g, '');
                  const countryCode = 'dialCode' in countryInfo ? countryInfo.dialCode : '';
                  const countryName = 'name' in countryInfo ? countryInfo.name : '';
                  formIk.handleChange({
                    target: { name: 'mobile', value: numericPhone.substring(countryCode.length) },
                  });
                  formIk.handleChange({
                    target: { name: 'countryCode', value: countryCode },
                  });
                  formIk.handleChange({
                    target: { name: 'countryName', value: countryName },
                  });
                }
              }}
              inputStyle={{ width: '100%' }}
              dropdownClass="text-left"
            />
            {formIk.errors.mobile && formIk.touched.mobile ? (
              <label className="text-sm text-red-600 block text-left mb-[5px]">
                {formIk.errors.mobile}
              </label>
            ) : null}
          </div>

          <div>
            <label className='block text-left mb-[5px]' htmlFor="personalContactNumber">Personal Contact Number</label>
            <PhoneInput
              country={'in'}
              value={fullPhoneNumber}
              onChange={(phone, countryInfo) => {
                if (typeof phone === 'string' && countryInfo && typeof countryInfo === 'object') {
                  const numericPhone = phone.replace(/\D/g, '');
                  const countryCode = 'dialCode' in countryInfo ? countryInfo.dialCode : '';
                  const countryName = 'name' in countryInfo ? countryInfo.name : '';
                  formIk.handleChange({
                    target: { name: 'personalContactNumber', value: numericPhone.substring(countryCode.length) },
                  });
                  formIk.handleChange({
                    target: { name: 'countryCode', value: countryCode },
                  });
                  formIk.handleChange({
                    target: { name: 'countryName', value: countryName },
                  });
                }
              }}
              inputStyle={{ width: '100%' }}
              dropdownClass="text-left"
            />
            {formIk.errors.personalContactNumber && formIk.touched.personalContactNumber ? (
              <label className="text-sm text-red-600 block text-left mb-[5px]">
                {formIk.errors.personalContactNumber}
              </label>
            ) : null}
          </div>

          <label className='block text-left mb-[5px]' htmlFor="permanentAddress">Permanent Address</label>
          <input className="w-full border mb-2.5 p-2 rounded-[3px] border-solid border-[#ccc]"
            type="text"
            id="permanentAddress"
            name="permanentAddress"
            value={formIk.values.permanentAddress}
            onChange={formIk.handleChange}
            onBlur={formIk.handleBlur}
            placeholder="Permanent Address"
          />
          {formIk.errors.permanentAddress && formIk.touched.permanentAddress ? (
            <label className="text-sm text-red-600 block text-left mb-[5px]">{formIk.errors.permanentAddress}</label>
          ) : null}

          <label className='block text-left mb-[5px]' htmlFor="currentAddress">Current Address</label>
          <input className="w-full border mb-2.5 p-2 rounded-[3px] border-solid border-[#ccc]"
            type="text"
            id="currentAddress"
            name="currentAddress"
            value={formIk.values.currentAddress}
            onChange={formIk.handleChange}
            onBlur={formIk.handleBlur}
            placeholder="Current Address"
          />
          {formIk.errors.currentAddress && formIk.touched.currentAddress ? (
            <label className="text-sm text-red-600 block text-left mb-[5px]">{formIk.errors.currentAddress}</label>
          ) : null}

          {/* 3. Employment Details */}
          <label className='block text-left mb-[5px]' htmlFor="qualificationAtAppointment">Qualification At The Time Of Appointment</label>
          <input className="w-full border mb-2.5 p-2 rounded-[3px] border-solid border-[#ccc]"
            type="text"
            id="qualificationAtAppointment"
            name="qualificationAtAppointment"
            value={formIk.values.qualificationAtAppointment}
            onChange={formIk.handleChange}
            onBlur={formIk.handleBlur}
            placeholder="Qualification At The Time Of Appointment"
          />
          {formIk.errors.qualificationAtAppointment && formIk.touched.qualificationAtAppointment ? (
            <label className="text-sm text-red-600 block text-left mb-[5px]">{formIk.errors.qualificationAtAppointment}</label>
          ) : null}

          <label className='block text-left mb-[5px]' htmlFor="designation">Designation</label>
          <select
            id="designation"
            name="designation"
            className="w-full border mb-2.5 p-2 rounded-[3px] border-solid border-[#ccc]"
            value={formIk.values.designation}
            onChange={formIk.handleChange}
            onBlur={formIk.handleBlur}
          >
            <option value='' disabled>Select Designation</option>
            {jobRole.map((jobRole: any) => (
              <option value={jobRole.designation}>{jobRole.designation}</option>
            ))}
          </select>
          {formIk.errors.designation && formIk.touched.designation ? (
            <label className="text-sm text-red-600 block text-left mb-[5px]">{formIk.errors.designation}</label>
          ) : null}

          <label className='block text-left mb-[5px]' htmlFor="department">Department</label>
          <select
            id="department"
            name="department"
            className="w-full border mb-2.5 p-2 rounded-[3px] border-solid border-[#ccc]"
            value={formIk.values.department}
            onChange={formIk.handleChange}
            onBlur={formIk.handleBlur}
          >
            <option value='' disabled>Select Department</option>
            {departments.map((departments: any) => (
              <option value={departments.id}>{departments.departmentName}</option>
            ))}
          </select>
          {formIk.errors.department && formIk.touched.department ? (
            <label className="text-sm text-red-600 block text-left mb-[5px]">{formIk.errors.department}</label>
          ) : null}

          <div className="text-left">
            <h1>Belongs to</h1>
            <div>
              <input
                type="radio"
                id="managerYes"
                name="isTeacher"
                value="true"
                checked={formIk.values.isTeacher === "true"}
                onChange={formIk.handleChange}
                onBlur={formIk.handleBlur}
              />
              <label htmlFor="managerYes" className="ml-2">
                Teaching
              </label>
          </div>
            <div>
              <input
                type="radio"
                id="managerNo"
                name="isTeacher"
                value="false"
                checked={formIk.values.isTeacher === "false"}
            onChange={formIk.handleChange}
            onBlur={formIk.handleBlur}
              />
              <label htmlFor="managerNo" className="ml-2">
              Non-Teaching
              </label>
            </div>
            {formIk.errors.isTeacher ? (
              <label className="text-sm text-red-600 block text-left mt-1">
                {formIk.errors.isTeacher}
              </label>
          ) : null}
          </div>

          <label className='block text-left mb-[5px]' htmlFor="experienceYear">Total Working Experience</label>
          <input className="w-full border mb-2.5 p-2 rounded-[3px] border-solid border-[#ccc]"
            type="text"
            placeholder="Enter Working Experience"
            id="experienceYear"
            name="experienceYear"
            value={formIk.values.experienceYear}
            onChange={formIk.handleChange}
            onBlur={formIk.handleBlur}
            pattern="[0-9,]*"
            inputMode="numeric"
          />
          {formIk.errors.experienceYear && formIk.touched.experienceYear ? (
            <label className="text-sm text-red-600 block text-left mb-[5px]">{formIk.errors.experienceYear}</label>
            ) : null}

          <label className='block text-left mb-[5px]' htmlFor="joiningDate">Date Of Joining</label>
          <input
            className="h-10 border w-full text-[32] p-2 rounded-[3px] border-solid border-[#ccc]"
            type="date"
            max="9999-12-31"
            id="joiningDate"
            name="joiningDate"
            value={formIk.values.joiningDate}
            onChange={formIk.handleChange}
            onBlur={formIk.handleBlur}
            placeholder="Date"
          />
          {formIk.errors.joiningDate && formIk.touched.joiningDate ? (
            <label className="text-sm text-red-600 block text-left mb-[5px]">{formIk.errors.joiningDate}</label>
          ) : null}

          <label className='block text-left mb-[5px]' htmlFor="location">Location(for Professional tax only)</label>
          <select
            id="location"
            name="location"
            className="w-full border mb-2.5 p-2 rounded-[3px] border-solid border-[#ccc]"
            value={formIk.values.location}
            onChange={formIk.handleChange}
            onBlur={formIk.handleBlur}
          >
            <option value='' disabled>Select State</option>
            <option value="Maharashtra">Maharashtra</option>
          </select>
          {formIk.errors.location && formIk.touched.location ? (
            <label className="text-sm text-red-600 block text-left mb-[5px]">{formIk.errors.location}</label>
          ) : null}

          <div className="text-left">
            <h1>University Accommodation</h1>
            <div>
              <input
                type="radio"
                id="universityAccommodationYes"
                name="universityAccommodation"
                value="true"
                checked={formIk.values.universityAccommodation === true}
                onChange={() => formIk.setFieldValue('universityAccommodation', true)}
            onBlur={formIk.handleBlur}
              />
              <label htmlFor="universityAccommodationYes" className="ml-2">
                Yes
              </label>
            </div>
            <div>
            <input
                type="radio"
                id="universityAccommodationNo"
                name="universityAccommodation"
                value="false"
                checked={formIk.values.universityAccommodation === false}
                onChange={() => formIk.setFieldValue('universityAccommodation', false)}
              onBlur={formIk.handleBlur}
            />
              <label htmlFor="universityAccommodationNo" className="ml-2">
                No
              </label>
            </div>
            {formIk.errors.universityAccommodation ? (
              <label className="text-sm text-red-600 block text-left mt-1">
                {formIk.errors.universityAccommodation}
              </label>
            ) : null}
          </div>

          <button type="submit" className="bg-[#007bff] text-white cursor-pointer text-[10px] px-5 py-2.5 rounded-[5px] border-[none] hover:bg-[#0056b3]">
            SUBMIT
          </button>
          <button
            type="button"
            className="bg-[hsl(0,100%,50%)] text-white cursor-pointer text-[10px] px-5 py-2.5 rounded-[5px] border-[none]"
            onClick={() => {
              props.close();
            }}
          >
            CLOSE
          </button>
        </div>
      </form>
    </div>
  );
}

export default PeopleUser;
